<div class="dropdown-container" (click)="open()" tabindex="0">
<!--    <input-->
<!--            type="text"-->
<!--            [(ngModel)]="searchTerm"-->
<!--            (focus)="open()"-->
<!--            placeholder="Поиск..."-->
<!--            class="search-input"-->
<!--    />-->

    <div class="input-wrapper">
        <input
                type="text"
                [(ngModel)]="searchTerm"
                (focus)="isOpen = true"
                placeholder="Поиск..."
                class="search-input"
        />
        <!-- Кнопка крестика для очистки -->
        <button
                *ngIf="searchTerm"
                class="clear-btn"
                (click)="clearSearch($event)"
                aria-label="Очистить"
        >
            &times;
        </button>
    </div>


    <div class="dropdown-list" *ngIf="isOpen">
        <div
                class="dropdown-item"
                *ngFor="let item of filteredItems()"
                (click)="selectItem(item)"
        >
            {{  this.getField(item, this.key) }}
        </div>

        <div *ngIf="filteredItems().length === 0" class="no-results">
            Ничего не найдено
        </div>
    </div>
</div>